/**
 * Helper which returns correctly typed object values of a given record.
 */
export function recordValues<ValueType>(
  record: Record<string, ValueType>,
): ValueType[] {
  return Object.values(record);
}

type NonNullValues<ObjectType> = {
  [KeyType in keyof ObjectType]: NonNullable<ObjectType[KeyType]>;
};

export function filterNullValues<ObjectType extends object>(
  obj: ObjectType,
): NonNullValues<ObjectType> {
  // oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
  const result: any = {};

  for (const key in obj) {
    if (obj[key] !== null) {
      result[key] = obj[key];
    }
  }

  return result;
}

export function recordEntries<
  KeyType extends string | number | symbol,
  ValueType,
>(record: Record<KeyType, ValueType>): [KeyType, ValueType][] {
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  return Object.entries(record) as [KeyType, ValueType][];
}
